import { BTN_TXT } from '../../constants/constants'
import CustomButton from './Button'

const CancelButton = ({ ...props }) => {
    return (
        <CustomButton
            variant="solid"
            style={{
                color: "#14286D",
                backgroundColor: "#F1F5FA",
                padding: "24px 32px",
                border: "none",
                fontSize:14,
                borderRadius: 5,
            }}
            {...props}
        >
            {BTN_TXT.CANCEL}
        </CustomButton>
    )
}

export default CancelButton